import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useNavigate } from 'react-router-dom'
import { postLogout } from '@/features/auth/api'
import {
  clearWorkspaceSession,
  readPersistedSession,
} from '@/features/auth/session/workspace-session'
import { AppPaths } from '@/config/app-paths'
import { useHttpClient } from '@/shared/api/http-client-context'

export function useLogoutMutation() {
  const client = useHttpClient()
  const navigate = useNavigate()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async () => {
      const session = readPersistedSession()
      if (session) {
        try {
          await postLogout(client, {
            sessionId: session.sessionId,
            refreshToken: session.refreshToken,
          })
        } catch {
          // Clear local session even when server logout fails (expired token, offline).
        }
      }
      clearWorkspaceSession()
    },
    onSettled: () => {
      queryClient.clear()
      navigate(AppPaths.login, { replace: true })
    },
  })
}
